import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { db } from "../firebase";
import { doc, getDoc } from "firebase/firestore";
import { Button } from "react-bootstrap";
import { IoArrowBack } from "react-icons/io5";

const EventDetails = () => {
  const { eventId } = useParams();
  const navigate = useNavigate();
  const [event, setEvent] = useState(null);

  useEffect(() => {
    document.body.style.backgroundColor = "#e0e0e0";

    return () => {
      document.body.style.backgroundColor = "";
    };
  }, []);

  useEffect(() => {
    const fetchEventDetails = async () => {
      if (!eventId) return;

      const eventDocRef = doc(db, "Event", eventId);
      const eventDoc = await getDoc(eventDocRef);

      if (eventDoc.exists()) {
        setEvent(eventDoc.data());
      }
    };

    fetchEventDetails();
  }, [eventId]);

  if (!event) return <p style={styles.loadingText}>Loading event details...</p>;

  return (
    <>
      <Button variant="dark" onClick={() => navigate(-1)} style={styles.backButton}>
        <IoArrowBack size={20} />
      </Button>

      <div style={styles.container}>
        <h2 style={styles.title}>{event.field1}</h2>
        <p style={styles.description}>{event.field2}</p>

        {event.images && event.images.length > 0 ? (
          <div style={styles.imageGallery}>
            {event.images.map((img, index) => (
              <img key={index} src={img} alt={`Event ${index}`} style={styles.eventImage} />
            ))}
          </div>
        ) : (
          <p style={styles.noImagesText}>No Images Available</p>
        )}
      </div>
    </>
  );
};

const styles = {
  backButton: {
    position: "absolute",
    top: "20px",
    left: "20px",
    width: "45px",
    height: "45px",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
    zIndex: 10,
  },
  container: {
    maxWidth: "900px",
    margin: "60px auto 40px",
    padding: "20px",
    background: "#ffffff",
    borderRadius: "10px",
    boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
    textAlign: "center",
    position: "relative",
  },
  title: {
    fontSize: "28px",
    fontWeight: "bold",
    marginTop: "10px",
    color: "#333",
  },
  description: {
    fontSize: "18px",
    color: "#555",
    marginBottom: "20px",
  },
  imageGallery: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
    gap: "15px",
    marginTop: "20px",
  },
  eventImage: {
    width: "100%",
    height: "auto",
    borderRadius: "8px",
    transition: "transform 0.3s ease-in-out",
    cursor: "pointer",
  },
  noImagesText: {
    fontSize: "18px",
    color: "#777",
  },
  loadingText: {
    fontSize: "18px",
    color: "#777",
    textAlign: "center",
    marginTop: "50px",
  },
};

export default EventDetails;
